import React from 'react';
import classNames from 'classnames';
import logger from '../../logger/logger';
import { Badge } from '@mui/material';
import InlineSVG from 'react-inlinesvg';
export var Icon = function (_a) {
    var iconName = _a.iconName, className = _a.className, size = _a.size, _b = _a.inverted, inverted = _b === void 0 ? false : _b, badgeCount = _a.badgeCount;
    try {
        var iconFile = require("../../../../src/images/icons/" + iconName + ".svg");
        if (!iconFile) {
            return null;
        }
        // Depending on webpack config, `iconFile` is
        // type string with value: <string of public path>
        // OR
        // type module with value: { default: <string of public path> }
        var src = typeof iconFile === 'string' ? iconFile : iconFile.default;
        var icon = (React.createElement(InlineSVG, { key: "iconName_" + className + "_" + inverted, src: src, className: classNames('icon', className, size, { inverted: inverted }), cacheRequests: true }));
        if (badgeCount) {
            return (React.createElement(Badge, { badgeContent: badgeCount, color: 'primary' }, icon));
        }
        else {
            return icon;
        }
    }
    catch (error) {
        logger.error(error.message);
        return null;
    }
};
export default Icon;
//# sourceMappingURL=Icon.js.map